import { gql } from '@apollo/client';

export interface Program {
  id: string;
  uuid: string;
  active: boolean;
  visible: boolean;
  name: string;
  studentFacingAcademicPartner: StudentFacingAcademicPartner;
  programKind?: string;
}

export interface StudentFacingAcademicPartner {
  uuid: string;
  name: string;
}

export interface ProgramsResponse {
  memberPrograms: Program[];
}

export const PROGRAMS = gql`
  query MEMBER_PROGRAMS {
    memberPrograms {
      id
      uuid
      active
      visible
      name
      programKind
      studentFacingAcademicPartner {
        uuid
        name
      }
    }
  }
`;
